import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import { AnnouncementPayload, AnnouncementResponse } from "./type";

export const AnnouncementApi = {
  getAnnouncement: (payload: AnnouncementPayload) =>
    axiosRequest.post<AnnouncementResponse>(
      "/",
      payloadHelper("Announcement", null, payload),
    ),
};
